/* eslint-disable jsx-a11y/anchor-is-valid */
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../core/Auth'
import {useGoogleReCaptcha} from 'react-google-recaptcha-v3'

const numberSchema = Yup.object().shape({
  phoneNumber: Yup.string()
    .required('Number is Required')
    .min(11, 'Must be a valid number')
    .max(11, 'Must be a valid number'),
})

const RegistrationNumberForm = () => {
  const navigate = useNavigate()
  const {saveRegistrationNumber} = useAuth()
  const {executeRecaptcha} = useGoogleReCaptcha()

  const formik = useFormik({
    initialValues: {phoneNumber: ''},
    validationSchema: numberSchema,
    onSubmit: async (values) => {
      try {
        console.log(values)
        if (!executeRecaptcha) return

        const token = await executeRecaptcha('registrationNumber')
        console.log(token)

        saveRegistrationNumber(values.phoneNumber)
        navigate('/auth/registration')
      } catch (error) {
        console.log(error)
      }
    },
  })

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-gray-900 fw-bolder mb-3'>Sign Up</h1>
        <div className='text-gray-500 fw-semibold fs-6'>IATL SMS PANEL</div>
      </div>
      {/* begin::Heading */}

      {/* begin::Heading */}
      <div className='mb-11'>
        <h1 className='text-dark fw-bolder mb-3 fs-2'>Number Verification</h1>
        {/* <div className='text-gray-500 fw-semibold fs-6'>Your Social Campaigns</div> */}
      </div>
      {/* begin::Heading */}

      {/* begin::Separator */}
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div> */}
      {/* end::Separator */}

      {/* begin::Form group */}
      <div className='fv-row mb-8'>
        <label className='required form-label fw-bolder text-dark fs-6'>Phone Number</label>
        <input
          type='text'
          autoComplete='off'
          {...formik.getFieldProps('phoneNumber')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber,
            },
            {
              'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber,
            }
          )}
        />
        {formik.touched.phoneNumber && formik.errors.phoneNumber && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.phoneNumber}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          Continue
        </button>
      </div>

      <div className='text-gray-500 text-center fw-semibold fs-6'>
        Already have an account?{' '}
        <Link to='/auth/login' className='link-primary'>
          Sign in
        </Link>
      </div>
      {/* end::Action */}
    </form>
  )
}

export default RegistrationNumberForm
